import type { RefObject } from 'react'
import { useCallback } from 'react'
import type { ShortcutConfig } from '@ztechapps/webui.util'
import { useKeyboardShortcut } from '@ztechapps/webui.util'
import type { MenuPopUpEnum } from './MenuPopUpEnum'
import { useContext } from './Context'

type UseQuickCreateShortcutProps = {
  shortcut: ShortcutConfig
  menuTarget: MenuPopUpEnum
  hasPermission: boolean
  toggleRef: RefObject<HTMLButtonElement>
}

export const useQuickCreateShortcut = ({
  shortcut,
  menuTarget,
  hasPermission,
  toggleRef,
}: UseQuickCreateShortcutProps) => {
  const { setOpen, setMenuTarget } = useContext()

  const action = useCallback(() => {
    if (!hasPermission) return
    setOpen(true)
    setMenuTarget({ show: menuTarget, target: toggleRef.current })
  }, [hasPermission, menuTarget, setOpen, setMenuTarget, toggleRef])

  useKeyboardShortcut({ ...shortcut, action, enabled: hasPermission })
}
